import { AccessibleImageType } from "../accessibleImage/accessibleImage";

export const marchingAntsGif: AccessibleImageType = {
    dark: "marching_ants",
    extension: "gif",
    light: "marching_ants_white"
};
